import { ComponentProps } from 'react';
import clamp from 'lodash/clamp';
import styled, { css } from 'styled-components';
import { up } from '../../utils/styles/breakpoints';
import { Box } from '../layout/Box';

interface MediaCoverProps extends ComponentProps<typeof Box> {
    ratio?: number;
}

export const MediaCover = styled(Box)
    .withConfig({ displayName: 'MediaCover' })
    .attrs<MediaCoverProps, MediaCoverProps>((props) => ({
        display: 'block',
        overflow: 'hidden',
        ...props,
    }))`
    position: relative;
    isolation: isolate;

    ${(props) =>
        props.ratio &&
        css`
            &::after {
                content: '';
                display: block;
                width: 100%;
                height: 0;
                padding-bottom: ${(100 / clamp(props.ratio, 9 / 16, 16 / 9)).toFixed(2)}%;
            }
        `}

    ${up('sm')} {
        max-height: 100%;
    }

    &&& > * {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 100%;
        height: 100%;
    }
`;

MediaCover.defaultProps = {
    backgroundColor: 'var(--placeholder)',
};
